module.exports = "https://static.wmbcdn.com/uniweb/images/193a44d4c420115dff94555098ee00d6.svg";